<div class="main-background main-body notranslate">
  <div #modalContainer></div>

  @if (shared.isMobileConst) {
  <app-header>
  </app-header>
  }

  <div class="d-flex align-items-stretch" [class.sidebar-collapsed]="!shared.isMobileConst && shared.sidebarCollapsed"
    [class.sidebar-hidden]="!shared.isMobileConst && shared.sidebarHidden">
    @if (!shared.isMobileConst) {
    <app-header>
    </app-header>
    }
    <div class="flex-fill overflow-x-auto">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Edge trigger strip — visible on left-edge hover (desktop, sidebar hidden only) -->
  @if (!shared.isMobileConst && shared.sidebarHidden) {
  <div class="sidebar-edge-trigger">
    <button type="button" class="sidebar-restore-btn" (click)="shared.setSidebarMode('expanded')"
      [title]="'sidebar.show' | translate" [attr.aria-label]="'sidebar.show' | translate">
      <i class="bi bi-layout-sidebar" aria-hidden="true"></i>
      <span>{{ 'sidebar.show' | translate }}</span>
    </button>
  </div>
  }

  @if (shared.loading && false) {
  <div class="loader-bg">
    <div class="loader-classic">
      <div class="spinner-border text-primary" role="status">
      </div>
    </div>
  </div>
  }

  <simple-notifications></simple-notifications>
  <app-right-menu></app-right-menu>

</div>
